/* ==========================================================================
   BALVOLT™ AUTO-ANIMATIONS
   Version: 1.0.0
   
   Self-contained animation system that automatically applies to Shopify 
   Horizon theme elements. No theme file modifications required.
   
   Add to theme.liquid before </body>:
   <script src="{{ 'balvolt-animations.js' | asset_url }}" defer></script>
   
   Or add via theme.liquid snippet injection (won't be overwritten):
   Create snippets/balvolt-scripts.liquid and include it in theme.liquid
   ========================================================================== */

(function() {
  'use strict';

  /* ========================================================================
     CONFIGURATION
     Adjust these selectors and settings as needed
     ======================================================================== */
  
  const CONFIG = {
    // Scroll-triggered fade-in animations
    fadeIn: {
      enabled: true,
      // Selectors for elements that should fade in on scroll
      selectors: [
        // Horizon theme sections
        '.shopify-section',
        'section.section-wrapper',
        // Common content blocks
        '.section__blocks > *',
        // Product grid items
        '.product-card',
        '.collection-product-card',
        // Rich text, images, groups
        '.block-image',
        '.block-text',
        '.block-group',
        // Custom sections
        '[class*="image-with-text"]',
        '[class*="multicolumn"]',
        '[class*="rich-text"]'
      ],
      // Elements to EXCLUDE from animations
      excludeSelectors: [
        '.shopify-section-header',
        '.shopify-section-footer', 
        '.header',
        '.footer',
        '.announcement-bar',
        '.cart-drawer',
        '.modal',
        '.popup',
        '[data-no-animate]'
      ],
      threshold: 0.1,        // How much of element must be visible (0-1)
      rootMargin: '0px 0px -80px 0px',  // Trigger slightly before fully in view
      duration: 600,         // Animation duration in ms
      staggerDelay: 100      // Delay between staggered children
    },

    // RGB border on email inputs
    rgbInputs: {
      enabled: true,
      selectors: [
        // Newsletter forms
        '.newsletter input[type="email"]',
        '.email-signup input[type="email"]',
        'form[action*="subscribe"] input[type="email"]',
        '[class*="newsletter"] input[type="email"]',
        '[class*="email-signup"] input[type="email"]',
        // Klaviyo forms
        '.klaviyo-form input[type="email"]',
        // Footer newsletter
        '.footer input[type="email"]',
        'footer input[type="email"]'
      ],
      borderWidth: 3,
      borderRadius: 8  // Set to 9999 for pill shape
    },

    // Pulse glow on primary CTAs
    pulseGlow: {
      enabled: true,
      selectors: [
        // Add to cart buttons
        '.product-form__submit',
        'button[name="add"]',
        '[data-add-to-cart]',
        '.add-to-cart',
        // Buy now buttons
        '.shopify-payment-button button',
        // You can add more specific selectors
      ]
    },

    // RGB text on specific keywords
    rgbText: {
      enabled: true,
      keywords: ['RGB', 'rgb'],  // Text content to highlight
      parentSelectors: ['h1', 'h2', 'h3', '.heading', '.title']  // Only within these
    }
  };


  /* ========================================================================
     STYLES INJECTION
     Injects required CSS that won't be overwritten by theme updates
     ======================================================================== */
  
  function injectStyles() {
    if (document.getElementById('balvolt-auto-animations-css')) return;
    
    const css = `
      /* ==========================================================================
         BALVOLT AUTO-ANIMATIONS CSS
         ======================================================================== */
      
      /* Fade-in animation */
      @keyframes balvoltFadeInUp {
        from {
          opacity: 0;
          transform: translateY(30px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
      
      /* Elements waiting to animate */
      .balvolt-will-animate {
        opacity: 0;
      }
      
      /* Elements that have animated in */
      .balvolt-animated {
        animation: balvoltFadeInUp ${CONFIG.fadeIn.duration}ms ease forwards;
      }
      
      /* Staggered children */
      .balvolt-stagger-animated > * {
        opacity: 0;
        animation: balvoltFadeInUp ${CONFIG.fadeIn.duration}ms ease forwards;
      }
      
      .balvolt-stagger-animated > *:nth-child(1) { animation-delay: ${CONFIG.fadeIn.staggerDelay * 1}ms; }
      .balvolt-stagger-animated > *:nth-child(2) { animation-delay: ${CONFIG.fadeIn.staggerDelay * 2}ms; }
      .balvolt-stagger-animated > *:nth-child(3) { animation-delay: ${CONFIG.fadeIn.staggerDelay * 3}ms; }
      .balvolt-stagger-animated > *:nth-child(4) { animation-delay: ${CONFIG.fadeIn.staggerDelay * 4}ms; }
      .balvolt-stagger-animated > *:nth-child(5) { animation-delay: ${CONFIG.fadeIn.staggerDelay * 5}ms; }
      .balvolt-stagger-animated > *:nth-child(6) { animation-delay: ${CONFIG.fadeIn.staggerDelay * 6}ms; }
      
      /* ==========================================================================
         RGB ANIMATED BORDER (Auto-wrapper)
         ======================================================================== */
      
      @keyframes balvoltRgbFlow {
        0% { background-position: 0% 50%; }
        100% { background-position: 300% 50%; }
      }
      
      .balvolt-rgb-input-wrapper {
        position: relative;
        display: inline-block;
        width: 100%;
        padding: ${CONFIG.rgbInputs.borderWidth}px;
        border-radius: ${CONFIG.rgbInputs.borderRadius}px;
        background: linear-gradient(
          120deg,
          #ff0000, #ff8000, #ffff00, #00ff00, 
          #00ffff, #0080ff, #8000ff, #ff00ff, #ff0000
        );
        background-size: 300% 300%;
        animation: balvoltRgbFlow 5s linear infinite;
      }
      
      .balvolt-rgb-input-wrapper > input {
        display: block;
        width: 100%;
        border: none !important;
        outline: none !important;
        // border-radius: ${CONFIG.rgbInputs.borderRadius - CONFIG.rgbInputs.borderWidth}px !important;
        // background: var(--color-background, #0a0a0a) !important;
      }
      
      .balvolt-rgb-input-wrapper > input:focus {
        outline: none !important;
        box-shadow: none !important;
      }
      
      /* ==========================================================================
         PULSE GLOW
         ======================================================================== */
      
      @keyframes balvoltPulseGlow {
        0%, 100% {
          box-shadow: 0 0 0 0 rgba(255, 179, 0, 0.4);
        }
        50% {
          box-shadow: 0 0 25px 12px rgba(255, 179, 0, 0.15);
        }
      }
      
      .balvolt-pulse-glow-auto {
        animation: balvoltPulseGlow 2.5s ease-in-out infinite;
      }
      
      /* ==========================================================================
         RGB TEXT
         ======================================================================== */
      
      @keyframes balvoltRgbText {
        0% { background-position: 0% 50%; }
        100% { background-position: 400% 50%; }
      }
      
      .balvolt-rgb-text-auto {
        background: linear-gradient(
          90deg,
          #ff0000, #ff8000, #ffff00, #00ff00, 
          #00ffff, #0080ff, #8000ff, #ff00ff, #ff0000
        );
        background-size: 400% 100%;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        animation: balvoltRgbText 4s linear infinite;
      }
      
      /* ==========================================================================
         ACCESSIBILITY - REDUCED MOTION
         ======================================================================== */
      
      @media (prefers-reduced-motion: reduce) {
        .balvolt-will-animate,
        .balvolt-animated,
        .balvolt-stagger-animated > * {
          opacity: 1 !important;
          transform: none !important;
          animation: none !important;
        }
        
        .balvolt-rgb-input-wrapper,
        .balvolt-rgb-text-auto {
          animation: none !important;
        }
        
        .balvolt-pulse-glow-auto {
          animation: none !important;
          box-shadow: 0 0 15px 5px rgba(255, 179, 0, 0.2) !important;
        }
      }
    `;
    
    const style = document.createElement('style');
    style.id = 'balvolt-auto-animations-css';
    style.textContent = css;
    document.head.appendChild(style);
  }


  /* ========================================================================
     FADE-IN ON SCROLL
     ======================================================================== */
  
  function initFadeInAnimations() {
    if (!CONFIG.fadeIn.enabled) return;
    
    const excludeSelector = CONFIG.fadeIn.excludeSelectors.join(', ');
    
    // Find all elements matching our selectors
    const elements = [];
    CONFIG.fadeIn.selectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        // Skip if matches exclude selector
        if (el.matches(excludeSelector) || el.closest(excludeSelector)) return;
        // Skip if already processed
        if (el.classList.contains('balvolt-will-animate')) return;
        // Skip if above the fold (already visible on load)
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.5) return;
        
        elements.push(el);
      });
    });
    
    // Mark elements for animation
    elements.forEach(el => {
      el.classList.add('balvolt-will-animate');
    });
    
    // Create intersection observer
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          el.classList.remove('balvolt-will-animate');
          el.classList.add('balvolt-animated');
          observer.unobserve(el);
        }
      });
    }, {
      threshold: CONFIG.fadeIn.threshold,
      rootMargin: CONFIG.fadeIn.rootMargin
    });
    
    elements.forEach(el => observer.observe(el));
  }


  /* ========================================================================
     RGB INPUT BORDERS
     ======================================================================== */
  
  function initRgbInputs() {
    if (!CONFIG.rgbInputs.enabled) return;
    
    const selector = CONFIG.rgbInputs.selectors.join(', ');
    const inputs = document.querySelectorAll(selector);
    
    inputs.forEach(input => {
      // Skip if already wrapped
      if (input.parentElement.classList.contains('balvolt-rgb-input-wrapper')) return;
      
      // Create wrapper
      const wrapper = document.createElement('div');
      wrapper.className = 'balvolt-rgb-input-wrapper';
      
      // Wrap input
      input.parentNode.insertBefore(wrapper, input);
      wrapper.appendChild(input);
    });
  }


  /* ========================================================================
     PULSE GLOW ON CTAS
     ======================================================================== */
  
  function initPulseGlow() {
    if (!CONFIG.pulseGlow.enabled) return;
    
    const selector = CONFIG.pulseGlow.selectors.join(', ');
    const buttons = document.querySelectorAll(selector);
    
    buttons.forEach(btn => {
      if (!btn.classList.contains('balvolt-pulse-glow-auto')) {
        btn.classList.add('balvolt-pulse-glow-auto');
      }
    });
  }


  /* ========================================================================
     RGB TEXT HIGHLIGHTING
     ======================================================================== */
  
  function initRgbText() {
    if (!CONFIG.rgbText.enabled) return;
    
    const parentSelector = CONFIG.rgbText.parentSelectors.join(', ');
    const parents = document.querySelectorAll(parentSelector);
    
    parents.forEach(parent => {
      // Skip if already processed
      if (parent.dataset.balvoltRgbProcessed) return;
      parent.dataset.balvoltRgbProcessed = 'true';
      
      CONFIG.rgbText.keywords.forEach(keyword => {
        // Use regex to find and wrap keywords
        const regex = new RegExp(`(${keyword})`, 'g');
        
        // Walk through text nodes only
        const walker = document.createTreeWalker(
          parent,
          NodeFilter.SHOW_TEXT,
          null,
          false
        );
        
        const textNodes = [];
        let node;
        while (node = walker.nextNode()) {
          if (regex.test(node.textContent)) {
            textNodes.push(node);
          }
        }
        
        textNodes.forEach(textNode => {
          const span = document.createElement('span');
          span.innerHTML = textNode.textContent.replace(
            regex,
            '<span class="balvolt-rgb-text-auto">$1</span>'
          );
          textNode.parentNode.replaceChild(span, textNode);
        });
      });
    });
  }


  /* ========================================================================
     INITIALIZATION
     ======================================================================== */
  
  function init() {
    // Inject styles first
    injectStyles();
    
    // Initialize all animation systems
    initFadeInAnimations();
    // initRgbInputs();
    initPulseGlow();
    // initRgbText();
    
    // Re-run on Shopify section load (for theme editor)
    document.addEventListener('shopify:section:load', () => {
      initFadeInAnimations();
      initRgbInputs();
      initPulseGlow();
      initRgbText();
    });
    
    // Re-run on dynamic content (AJAX cart, infinite scroll, etc.)
    const mutationObserver = new MutationObserver((mutations) => {
      let shouldReinit = false;
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length > 0) {
          shouldReinit = true;
        }
      });
      if (shouldReinit) {
        // Debounce re-initialization
        clearTimeout(window.balvoltReinitTimeout);
        window.balvoltReinitTimeout = setTimeout(() => {
          initRgbInputs();
          initPulseGlow();
        }, 100);
      }
    });
    
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();